import React, { Suspense } from 'react';
import Header from './Header';
import PitcureTest from './PitcureTest';

const SideLeft = () => {

    return ( 
        <>
            <div className='side-left-header w-100 d-inline-block'>
                <Header/>
            </div>
            <div className='side-left-body w-100 d-inline-block css-nkyeax' >
                <Suspense fallback={<div>لطفا منتظر بمانید...</div>}>
                    <PitcureTest/>
                </Suspense>
            </div>
        </>
    );
}
 
export default SideLeft;